class StateController {
  constructor() {
    this.name = 'state';
  }
}

export default StateController;



// WEBPACK FOOTER //
// ./client/app/components/state/state.controller.js